import { render } from "./UiConfirmModal.vue?vue&type=template&id=332c55e0&lang=pug"
import script from "./UiConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UiConfirmModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__